import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { LocalStorageService } from './local-storage.service';
declare const ChurnZero: any;
@Injectable({
    providedIn: 'root'
})
export class ChurnZeroService {
    userData: any;
    constructor(private localStorageService: LocalStorageService) { }
    initialize(): void {
        this.userData = this.localStorageService.get('userData');
        if (!this.userData) {
            return;
        }
        if (typeof ChurnZero === 'undefined' || !ChurnZero?.push) {
            console.error(
                'ChurnZero SDK not loaded. Check the script in index.html.'
            );
            return;
        }
        let appkey = environment.churnZeroAppKey;
        ChurnZero?.push(['setAppKey', appkey]);
        ChurnZero?.push([
            'setContact',
            this.userData.uuid,
            this.userData.email
        ]);
        // console.log('ChurnZero initialized successfully.');
    }
    trackEvent(eventName: string): void {
        this.userData = this.localStorageService.get('userData');
        if (typeof ChurnZero === 'undefined' || !ChurnZero?.push) {
            console.error('Invalid track event called.');
            return;
        }
        const data = {
            user_role: 'seller',
            country:
                this.userData?.customer_details?.country?.country_name || null,
            user_email: this.userData?.email
        };

        ChurnZero?.push(['trackEvent', eventName, '', '', data]);
    }
}
